'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './main.routes';
import list from './list';
import show from './show'

export default angular.module('logServerApp.main', [uiRouter, list, show])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/index.js